import { createRouter, createWebHistory } from 'vue-router';

import Certifications from '../components/certifications/Certifications.vue';
import Codes from '../components/codes/Codes.vue';
import Hospitals from '../components/hospitals/Hospitals.vue';
import JoinLinkHospitals from '../components/join_link/JoinLinkHospitals.vue';
import JoinLinkUsers from '../components/join_link/JoinLinkUsers.vue';
import Login from '../components/login/Login.vue';
import Logout from '../components/login/Logout.vue';
import QuestionnaireResponses from '../components/questionnaire_responses/QuestionnaireResponses.vue';
import Questionnaires from '../components/questionnaires/Questionnaires.vue';
import Tenants from '../components/tenants/Tenants.vue';
import Users from '../components/users/Users.vue';

import { LOCAL_STORAGE_KEY, SESSION_KEY } from './utils';

const router = createRouter({
  base: __dirname,
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      label: 'Users',
      iconClass: 'dripicons-user',
      alias: '/',
      props: {
        access: {
          route: ['root', 'admin', 'user'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['root', 'admin'],
          grid_delete_control: ['root', 'admin', 'user'],
          grid_view_control: ['root', 'admin', 'user'],
        },
      },
    },
    {
      path: '/hospitals',
      name: 'hospitals',
      component: Hospitals,
      label: 'Hospitals',
      iconClass: 'dripicons-medical',
      props: {
        access: {
          route: ['root', 'admin', 'user'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['user', 'admin', 'root'],
          grid_delete_control: ['root'],
          grid_view_control: ['user', 'admin', 'root'],
        },
      },
    },
    {
      path: '/joinlink',
      name: 'joinlink',
      label: 'Join Link',
      iconClass: 'dripicons-message',
      alias: '/',
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
        },
      },
      subitems: ['hospitals', 'users'],
    },
    {
      path: '/joinlink/hospitals',
      component: JoinLinkHospitals,
      name: 'joinLinkHospitals',
      nosidebar: true,
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['root', 'admin'],
          grid_delete_control: ['root', 'admin'],
          grid_view_control: ['root', 'admin'],
        },
      },
    },
    {
      path: '/joinlink/users',
      component: JoinLinkUsers,
      name: 'joinLinkUsers',
      nosidebar: true,
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['root', 'admin'],
          grid_delete_control: ['root', 'admin'],
          grid_view_control: ['root', 'admin'],
        },
      },
    },
    {
      path: '/certifications',
      name: 'certifications',
      component: Certifications,
      label: 'certifications',
      iconClass: 'dripicons-trophy',
      props: {
        access: {
          route: ['root'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
        },
      },
    },
    {
      path: '/codes',
      name: 'codes',
      component: Codes,
      label: 'Codes',
      iconClass: 'dripicons-checklist',
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['root', 'admin'],
          grid_delete_control: ['root', 'admin'],
          grid_view_control: ['root', 'admin'],
        },
      },
    },
    {
      path: '/tenants',
      name: 'tenants',
      component: Tenants,
      label: 'Tenants',
      iconClass: 'dripicons-user-group',
      props: {
        access: {
          route: ['root'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['admin', 'root'],
          grid_delete_control: ['root'],
          grid_view_control: ['admin', 'root'],
        },
      },
    },
    {
      path: '/questionnaires',
      name: 'questionnaires',
      component: Questionnaires,
      label: 'Questionnaires',
      iconClass: 'dripicons-network-3',
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
        },
      },
    },
    {
      path: '/responses',
      name: 'responses',
      component: QuestionnaireResponses,
      label: 'Responses',
      iconClass: 'dripicons-document',
      props: {
        access: {
          route: ['root', 'admin'],
          all: ['root', 'admin', 'user'],
          root: ['root'],
          admin: ['admin'],
          privileged: ['root', 'admin'],
          grid_edit_control: ['root', 'admin'],
          grid_delete_control: ['root', 'admin'],
          grid_view_control: ['root', 'admin'],
        },
      },
    },
  ],
});

router.beforeEach((to) => {
  const sessionObject = window.sessionStorage.getItem(SESSION_KEY) || window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!sessionObject && to.name !== 'login') return { name: 'login' };
  if (sessionObject && to.name === 'login') return { name: 'users' };
  return true;
});

export default router;
